/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientMapping } from '../../models/client-mapping';

export interface ClientManagementGetMappingGetMappingClientIdGet$Plain$Params {
  clientId: string;
}

export function clientManagementGetMappingGetMappingClientIdGet$Plain(http: HttpClient, rootUrl: string, params: ClientManagementGetMappingGetMappingClientIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientMapping>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetMappingGetMappingClientIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientMapping>;
    })
  );
}

clientManagementGetMappingGetMappingClientIdGet$Plain.PATH = '/ClientManagement/GetMapping/GetMapping/{clientId}';
